import { Button } from '@/app/common/components/button/Button'
import { Badge } from '@/shad/ui/badge'
import { Checkbox } from '@/shad/ui/checkbox'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shad/ui/dropdown-menu'
import { ColumnDef } from '@tanstack/react-table'
import { Edit, Eye, MoreHorizontal } from 'lucide-react'
import { ApprovalRule } from '../../schema'
import { removeUnderscoresAndMakeFirstLetterCapital } from '../../utils'

export type RuleTableActions = {
  onEditRule: (rule: ApprovalRule) => void
  onViewDetails: (rule: ApprovalRule) => void
}

export const createColumns = (
  actions: RuleTableActions
): ColumnDef<ApprovalRule>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected()}
        onCheckedChange={() => table.toggleAllPageRowsSelected()}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={() => row.toggleSelected()}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
    enableMultiSort: true,
  },
  {
    accessorKey: 'name',
    header: 'Rule Name',
    cell: ({ row }) => (
      <div className="font-medium">{row.getValue('name')}</div>
    ),
  },
  {
    accessorKey: 'target_type_code',
    header: 'Target Type',
    cell: ({ row }) => (
      <Badge variant={'secondary'}>
        {removeUnderscoresAndMakeFirstLetterCapital(
          row.getValue('target_type_code')
        )}
      </Badge>
    ),
  },
  {
    accessorKey: 'target_name',
    header: 'Target Name',
    cell: ({ row }) => <div>{row.getValue('target_name')}</div>,
  },
  {
    accessorKey: 'approval_type_code',
    header: 'Approval Type',
    cell: ({ row }) => (
      <Badge variant="secondary" className="text-xs">
        {removeUnderscoresAndMakeFirstLetterCapital(
          row.getValue('approval_type_code')
        )}
      </Badge>
    ),
  },
  {
    accessorKey: 'is_active',
    header: 'Status',
    cell: ({ row }) => (
      <Badge variant={row.getValue('is_active') ? 'green' : 'secondary'}>
        {row.getValue('is_active') ? 'Active' : 'Inactive'}
      </Badge>
    ),
  },
  {
    id: 'actions',
    enableHiding: false,
    cell: ({ row }) => {
      const rule = row.original

      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button size="square" variant="outline">
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => actions.onViewDetails(rule)}>
              <Eye className="h-4 w-4 mr-2" />
              View Details
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => actions.onEditRule(rule)}>
              <Edit className="h-4 w-4 mr-2" />
              Edit Rule
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )
    },
  },
]
